'use client';

import './_text-input.scss';

export default function TextInput({
  className = 'Text-input__field',
  type = 'text',
  label = '',
  name = '',
  labelVisuallyHidden = false,
  placeholder = '',
  onChange = () => {},
  value = ''
}) {
  const clientId = `input_${name}`;
  let elClassName = 'Text-input';
  if (className) {
    elClassName += ` ${className}`;
  }
  let labelClassName = 'Text-input__label';
  if (labelVisuallyHidden) {
    labelClassName += ' visually-hidden';
  }

  return (
    <div className={elClassName}>
      <label className={labelClassName} htmlFor={clientId}>
        {label}
      </label>
      <input
        className={className}
        type={type}
        name={name}
        id={clientId}
        value={value || ''}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </div>
  );
}
